import React from "react";
import rightTopFilter from "../../assets/images/right-ads-mid.gif";
import bottomAds from "../../assets/images/right-ads-bottom.gif";

const RightSideFilter = () => {
  return (
    <React.Fragment>
      <td className="right">
        <div id="dnw_right">
          <div style={{ height: "auto" }}>
            <img id="rightTopFilter" src={rightTopFilter} alt="right-ads" width="100%"/>
            <div className="clear" />
          </div>
          <div>
            <div>
              <div className="modulesLR moduleBrown">
                <div className="body-l">
                  <div className="body-r">
                    <ul className="list_news">
                      <li>
                        <a href="/">Thay đổi giờ mở thưởng Xổ số Miền Bắc</a>
                      </li>
                      <li>
                        <a href="/">
                          ĐỔI SỐ TRÚNG ĐẶC BIỆT Ở ĐÂU &amp; THỦ TỤC NHƯ THẾ NÀO
                          ?... THINHNAM TP HCM
                        </a>
                      </li>
                      <li>
                        <a href="/">Mức chi hoa hồng đại lý xổ số</a>
                      </li>
                      <li>
                        <a href="/">
                          Thuế thu nhập trúng xổ số &amp; cơ cấu giải thưởng từ
                          01/01/2017
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          Nghị định 78/2012/NĐ-CP về kinh doanh xổ số
                        </a>
                      </li>
                      <li>
                        <a href="/">KHUYẾN CÁO KHI ĐỔI SỐ TRÚNG</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="clear" />
            </div>
          </div>
          <div>
                <img id="randomImage" src={bottomAds} alt="ads" width="100%"/>
            </div>
            <div className="clear"/>
        </div>
      </td>
    </React.Fragment>
  );
};

export default RightSideFilter;
